const USERNAME_KEY = 'username';
const PASSWORD_KEY = 'password';
const REMEMBER = 'remember_me';

export function setLoginInfo(username: string, password: string, remember: boolean) {
  localStorage.setItem(USERNAME_KEY, username);
  localStorage.setItem(PASSWORD_KEY, password);
  localStorage.setItem(REMEMBER, String(remember));
}

export function getLoginInfo() {
  const username = localStorage.getItem(USERNAME_KEY);
  const password = localStorage.getItem(PASSWORD_KEY);
  const remember = localStorage.getItem(REMEMBER) ? Boolean(localStorage.getItem(REMEMBER)) : false;

  if (username && password && remember) {
    return { username, password, remember };
  }
  return null;
}

export function clearLoginInfo() {
  localStorage.removeItem(USERNAME_KEY);
  localStorage.removeItem(PASSWORD_KEY);
  localStorage.removeItem(REMEMBER);
}
